module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"watch":"Watch","watching":"Watching"}}')
  delete Component.options._Ctor
}
